import { render, staticRenderFns } from "./peopleList.vue?vue&type=template&id=4fb3a03c&scoped=true&"
import script from "./peopleList.vue?vue&type=script&lang=js&"
export * from "./peopleList.vue?vue&type=script&lang=js&"
import style0 from "./peopleList.vue?vue&type=style&index=0&id=4fb3a03c&scoped=true&lang=css&"
import style1 from "./peopleList.vue?vue&type=style&index=1&id=4fb3a03c&lang=scss&scoped=true&"
import style2 from "./peopleList.vue?vue&type=style&index=2&id=4fb3a03c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb3a03c",
  null
  
)

export default component.exports